<template>

<div class="metrics">

   <div class="metrics-item is-queue">

        <div class="metrics-item-metric is-big" data-size="3" v-tooltip="'The current size of the sync queue.'">
            <div class="metrics-item-metric-value">{{ data.queue.size | prettyNumber }}</div>
            <div class="metrics-item-metric-label">Queue Size</div>
        </div>

        <div class="metrics-item-metric is-big" data-size="3" v-tooltip="'The number of users synced today.'">
            <div class="metrics-item-metric-value">{{ data.syncs.total | prettyNumber }}</div>
            <div class="metrics-item-metric-label">Syncs Today</div>
        </div>

        <div class="metrics-item-metric is-icon" data-size="3" v-tooltip="'The success rate of syncs today.'">
            <div class="metrics-item-metric-value">{{ data.syncs.rate }}<small>%</small></div>
            <div class="metrics-item-metric-label">Success Rate</div>
            <i class="metrics-item-metric-icon fa-regular fa-chart-pie-simple" />
        </div>

        <div class="metrics-item-metric is-chart is-blue" data-size="3">

            <div class="metrics-item-metric-bar" v-for="(day, index) in syncDays" :key="index" v-tooltip="day.label">
                <div class="metrics-item-metric-bar-value" :style="{height: day.height + '%'}"></div> 
            </div>

        </div>

   </div>

   <div class="metrics-item is-syncs">

        <div class="metrics-item-metric is-big is-line" data-size="3">

            <div class="metrics-item-metric-line" v-tooltip="'Syncs today for accounts new to GeekGroup: signing up, or added to a group before ever syncing.'">
                <div class="metrics-item-metric-label">New Users</div>
                <div class="metrics-item-metric-value is-shade-1">{{ data.syncs.new | prettyNumber }}</div>
            </div>

            <div class="metrics-item-metric-line" v-tooltip="'Syncs today that someone asked for: their own account, or a profile they were viewing.'">
                <div class="metrics-item-metric-label">Manual Syncs</div>
                <div class="metrics-item-metric-value is-shade-2">{{ data.syncs.manual | prettyNumber }}</div>
            </div>

            <div class="metrics-item-metric-line" v-tooltip="'Syncs today run on the daily and weekly schedule, and for groups.'">
                <div class="metrics-item-metric-label">Automated Syncs</div>
                <div class="metrics-item-metric-value is-shade-3">{{ data.syncs.automated | prettyNumber }}</div>
            </div>

        </div>

        <div class="metrics-item-metric is-big is-line" data-size="3">
            
            <div class="metrics-item-metric-line" v-tooltip="'The number of high priority syncs today.'">
                <div class="metrics-item-metric-label">High Priority</div>
                <div class="metrics-item-metric-value is-green">{{ data.syncs.high | prettyNumber }}</div>
            </div>

            <div class="metrics-item-metric-line" v-tooltip="'The number of medium priority syncs today.'">
                <div class="metrics-item-metric-label">Medium Priority</div>
                <div class="metrics-item-metric-value is-yellow">{{ data.syncs.medium | prettyNumber }}</div>
            </div>

            <div class="metrics-item-metric-line" v-tooltip="'The number of low priority syncs today.'">
                <div class="metrics-item-metric-label">Low Priority</div>
                <div class="metrics-item-metric-value is-red">{{ data.syncs.low | prettyNumber }}</div>
            </div>

        </div>

        <div class="metrics-item-metric is-small" data-size="2" v-tooltip="'Offline copies of members\' own data built today for Pocket Edition and Lightning Mode.'">
            <div class="metrics-item-metric-value">{{ data.snapshots.user | prettyNumber }}</div>
            <div class="metrics-item-metric-label">User Snapshots</div>
        </div>

        <div class="metrics-item-metric is-small" data-size="2" v-tooltip="'Offline copies of groups built today for Pocket Edition and Lightning Mode.'">
            <div class="metrics-item-metric-value">{{ data.snapshots.group | prettyNumber }}</div>
            <div class="metrics-item-metric-label">Group Snapshots</div>
        </div>

        <div class="metrics-item-metric is-small" data-size="2" v-tooltip="'Offline copies of GeekBuddies lists built today for Pocket Edition and Lightning Mode.'">
            <div class="metrics-item-metric-value">{{ (data.snapshots.buddies || 0) | prettyNumber }}</div>
            <div class="metrics-item-metric-label">GeekBuddies Snapshots</div>
        </div>

   </div>

   <transition-group name="list" tag="div" class="metrics-item is-recent">

        <div class="metrics-item-metric-recent" v-for="recent in recentFinal" :key="recent.id">

            <div class="metrics-item-metric-label"><span class="metrics-item-metric-prefix" v-if="recent.prefix">{{ recent.prefix }}</span>{{ recent.name }}<small>{{ recent.date | fromNow }}</small></div>

            <div class="metrics-item-metric-value is-green" v-if="recent.priority === 'high'">High</div>
            <div class="metrics-item-metric-value is-yellow" v-if="recent.priority === 'medium'">Med</div>
            <div class="metrics-item-metric-value is-red" v-if="recent.priority === 'low'">Low</div>

            <div class="metrics-item-metric-value is-green" v-if="recent.success">OK</div>
            <div class="metrics-item-metric-value is-red" v-if="!recent.success">Fail</div>

        </div>

   </transition-group>

</div>

</template>

<script>

import _ from 'underscore'

export default {

    props: ['data'],

    computed: {

        syncDays: function() {

            var days = []

            var max = _.max(this.data.syncs.days, function(day) {

                return day.value

            })

            _.each(this.data.syncs.days, function(day, index) {

                var label = index.toString() + ' days ago<small>' + this.filter('prettyNumber', day.value) + '</small>'

                if (index === 0) label = 'Today<small>' + this.filter('prettyNumber', day.value) + '</small>'
                if (index === 1) label = 'Yesterday<small>' + this.filter('prettyNumber', day.value) + '</small>'

                days.push({
                    label: label,
                    height: (100 / max.value) * day.value
                })

            }.bind(this))

            return days.reverse()

        },

        recentFinal: function() {

            return this.data.recent.slice(0, 5)

        }

    },

    methods: {

        filter: function(name, value, param) {

			return this.$options.filters[name](value, param)

		}

    }

}

</script>

<style scoped>

.metrics {
    display: grid;
    grid-template-columns: 1fr 1fr 320px;
    position: absolute;
    left: 50%;
    grid-gap: 64px;
    width: 100%;
    max-width: 1272px;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
}

.is-tablet .metrics {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    padding: 20px;
    left: auto;
    position: relative;
    top: auto;
    transform: none;
}

.is-mobile .metrics {
    grid-template-columns: 1fr;
    left: auto;
    position: relative;
    top: auto;
    transform: none;
    grid-gap: 40px;
    padding: 10px;
}

.metrics-item {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}

.is-mobile .metrics-item {
    grid-gap: 5px;
}

.metrics-item.is-recent {
    grid-gap: 5px;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
}

.is-tablet .metrics-item.is-recent {
    grid-column: span 2;
}

.metrics-item-metric {
    background-color: rgba(4, 18, 26, 1);
    padding: 20px;
}

.is-mobile .metrics-item-metric {
    background-color: rgba(20, 55, 76, 1);
}

.metrics-item-metric[data-size="6"] {
    grid-column: span 6;
}

.metrics-item-metric[data-size="4"] {
    grid-column: span 4;
}

.is-mobile .metrics-item-metric[data-size="4"] {
    grid-column: span 6;
}

.metrics-item-metric[data-size="3"] {
    grid-column: span 3;
}

.is-mobile .metrics-item-metric[data-size="3"] {
    grid-column: span 6;
}

.metrics-item-metric[data-size="2"] {
    grid-column: span 2;
}

.is-mobile .metrics-item-metric[data-size="2"] {
    grid-column: span 6;
}

.metrics-item-metric.is-big {
    height: 132px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.metrics-item-metric.is-line {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-gap: 5px;
    background-color: transparent;
    padding: 0px;
}

.metrics-item-metric.is-big:not(.is-line) .metrics-item-metric-value {
    font-size: 48px;
    font-weight: 700;
    text-align: center;
    font-family: "Doto", sans-serif;
}

.metrics-item-metric.is-big:not(.is-line) .metrics-item-metric-label {
    font-size: 16px;
    font-weight: 400;
    margin-top: 4px;
    text-align: center;
    font-family: "Roboto Mono", sans-serif;
    opacity: 0.75;
}

.metrics-item-metric-line {
    background-color: rgba(4, 18, 26, 1);
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
}

.is-mobile .metrics-item-metric-line {
    background-color: rgba(20, 55, 76, 1);
}

.metrics-item-metric-line  .metrics-item-metric-value {
    font-family: "Doto", sans-serif;
    font-size: 16px;
    font-weight: 700;
    margin-top: 0px;
    padding: 5px 10px;
    margin-right: 10px;
    text-align: left;
}

.metrics-item-metric-line  .metrics-item-metric-value.is-green {
    background-color: #63ff85;
    color: #2d3c2d;
}

.metrics-item-metric-line  .metrics-item-metric-value.is-yellow {
    background-color: #fff363;
    color: #403c0e;
}

.metrics-item-metric-line  .metrics-item-metric-value.is-red {
    background-color: #ff6363;
    color: #4a0808;
}

/* Neutral counts (why syncs ran): shades of the sync-chart cyan, so no
   good / bad reading the way the priority greens and reds carry. */
.metrics-item-metric-line  .metrics-item-metric-value.is-shade-1 {
    background-color: #63f3ff;
    color: #0b3a40;
}

.metrics-item-metric-line  .metrics-item-metric-value.is-shade-2 {
    background-color: #3fcfdc;
    color: #0b3a40;
}

.metrics-item-metric-line  .metrics-item-metric-value.is-shade-3 {
    background-color: #2aa6b4;
    color: #062328;
}

.metrics-item-metric-line:hover {
    background-color: rgba(17, 30, 38, 1);
}

.metrics-item-metric-line  .metrics-item-metric-label {
    font-family: "Roboto Mono", sans-serif;
    font-size: 12px;
    opacity: 0.75;
    font-weight: 400;
    margin-top: 0px;
    padding-left: 10px;
    text-align: left;
}

.metrics-item-metric.is-icon,
.metrics-item-metric.is-small {
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.metrics-item-metric.is-icon .metrics-item-metric-value,
.metrics-item-metric.is-small .metrics-item-metric-value {
    font-size: 24px;
    font-weight: 700;
    font-family: "Doto", sans-serif;
}

.metrics-item-metric .metrics-item-metric-value small {
    font-size: 16px;
    font-family: "Roboto Mono", sans-serif;
    opacity: 0.5;
}

.metrics-item-metric.is-icon .metrics-item-metric-label,
.metrics-item-metric.is-small .metrics-item-metric-label {
    font-size: 12px;
    font-weight: 400;
    margin-top: 2px;
    font-family: "Roboto Mono", sans-serif;
    opacity: 0.75;
}

.metrics-item-metric.is-icon .metrics-item-metric-icon {
    font-size: 32px;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
}

.metrics-item-metric.is-icon .metrics-item-metric-icon.is-green {
    color: #63ff85;
}

.metrics-item-metric.is-icon .metrics-item-metric-icon.is-red {
    color: #ff6363;
}

.metrics-item-metric.is-chart {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    height: 80px;
    padding: 0px;
    grid-gap: 1px;
}

.metrics-item-metric:not(.is-chart):not(.is-line):hover {
    background-color: rgba(17, 30, 38, 1);
}

.metrics-item-metric-bar {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.metrics-item-metric-bar:hover {
    background-color: rgba(17, 30, 38, 1);
}

.metrics-item-metric-bar-value {
    width: 100%;
}

.metrics-item-metric.is-chart.is-purple .metrics-item-metric-bar-value {
    background-color: #9063ff;
}

.metrics-item-metric.is-chart.is-purple .metrics-item-metric-bar:hover .metrics-item-metric-bar-value {
    background-color: #7247da;
}

.metrics-item-metric.is-chart.is-blue .metrics-item-metric-bar-value {
    background-color: #63f3ff
}

.metrics-item-metric.is-chart.is-blue .metrics-item-metric-bar:hover .metrics-item-metric-bar-value {
    background-color: #4ed6e1;
}

/* snap/ ahead of an offline snapshot build's name, faded like the time. */
.metrics-item-metric-recent .metrics-item-metric-prefix {
    opacity: 0.5;
}

.metrics-item-metric-recent:hover {
    background-color: rgba(17, 30, 38, 1);
}

.metrics-item-metric-recent {
    background-color: rgba(4, 18, 26, 1);
    display: grid;
    grid-column: span 6;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    transition: transform 300ms ease-in-out;
}

.is-tablet .metrics-item-metric-recent {
    padding: 10px 0px;
}

.is-mobile .metrics-item-metric-recent {
    background-color: rgba(20, 55, 76, 1);
    padding: 10px 0px;
}

.metrics-item-metric-recent  .metrics-item-metric-value {
    font-family: "Doto", sans-serif;
    font-size: 16px;
    font-weight: 700;
    margin-top: 0px;
    padding: 5px 10px;
    margin-right: 10px;
    text-align: left;
}

.metrics-item-metric-recent  .metrics-item-metric-value.is-green {
    background-color: #63ff85;
    color: #2d3c2d;
}

.metrics-item-metric-recent  .metrics-item-metric-value.is-yellow {
    background-color: #fff363;
    color: #403c0e;
}

.metrics-item-metric-recent  .metrics-item-metric-value.is-red {
    background-color: #ff6363;
    color: #4a0808;
}

.metrics-item-metric-recent  .metrics-item-metric-label {
    font-family: "Roboto Mono", sans-serif;
    font-size: 14px;
    opacity: 1;
    font-weight: 400;
    margin-top: 0px;
    padding-left: 10px;
    text-align: left;
}

.metrics-item-metric-recent  .metrics-item-metric-label small {
    display: block;
    opacity: 0.75;
    font-size: 12px;
    margin-top: 2px;
}

.list-enter, .list-leave-to {
    opacity: 0;
    transform: translateX(100px);
}

.list-leave-active {
    position: absolute;
}

</style>
